export enum Visibility {
  Visible = 'visible',
  Disabled = 'disabled',
  Hidden = 'hidden',
}
export enum Align {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
export enum SectionType {
  Body = 'body',
  Block = 'block',
  Modal = 'modal',
}
export enum Pagination {
  First = 'first',
  Prev = 'prev',
  Next = 'next',
  Last = 'last',
}
export interface Option {
  value: string;
  title: string;
  visibility?: Visibility;
}
export interface Section {
  id?: string;
  visibility?: Visibility;
  type?: SectionType;
  header?: Item[];
  content: Item[];
  footer?: Item[];
  style?: object;
}

export interface Item {
  [key: string]: string | unknown;
  id: string;
  class: string;
  errorMsg?: string;
  visibility?: Visibility;
  required?: boolean;
  error?: boolean;
  value?: string | { [key: string]: string };
  type?: string;
}
export interface Form {
  id: string;
  title?: string;
  visibility?: Visibility;
  errorMsg?: string;
  sections: Section[];
}

export enum gridType {
  onecloumn = 'one_cloumn',
  twoclumn = 'two_column',
}
export interface Grid {
  components: { [key: string]: string[] };
  header: { class: string; extra: { steps: Array<string>; active: number } };
  type: gridType;
}
export interface FileProps {
  path: string;
  mimeType: string;
  name: string;
}
